import script from "./GetStarted.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetStarted.vue?vue&type=script&setup=true&lang=ts"

import "./GetStarted.vue?vue&type=style&index=0&id=97d6a606&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d6a606"]])

export default __exports__